import { OrderAuthorizationEnum } from "@utils/getOrderAuthorization";
import { BRAND_NAME, ROUTES } from "@constants";
import { useHistory } from "react-router-dom";
import { ICatalogOffer } from "@features/cart/ICart";
import { useTranslation } from "react-i18next";
import { BUTTON_IDS } from "@features/dataLayer/buttonIds";
import { ButtonProps } from "@mui/material";

interface IParams {
    offer: ICatalogOffer;
    orderAuthorization: OrderAuthorizationEnum | undefined;
    handleAddMobileOffer(selectedOffer: ICatalogOffer): void;
    hasMobileOfferInCart: boolean;
}

export const useHomeMobileOffer = (props: IParams) => {
    const {
        offer,
        offer: { usages },
        orderAuthorization,
        handleAddMobileOffer,
        hasMobileOfferInCart,
    } = props;

    const { push } = useHistory();

    const { t } = useTranslation(["home", "glossary", "common"]);

    const [firstUsage, ...otherUsages] = usages;

    const onClick = () => {
        orderAuthorization === OrderAuthorizationEnum.OrderOk
            ? handleAddMobileOffer(offer)
            : push(ROUTES.CART_PAGE_URL);
    };

    const getButtonProps = (): { id: string; label: string; variant: ButtonProps["variant"] } => {
        if (orderAuthorization === OrderAuthorizationEnum.OrderImpossible) {
            return {
                id: BUTTON_IDS.MOBILE_FLOW.PAGE_CTA.GO_TO_MY_GOMO,
                label: t("home:goMyAccount", { brand: BRAND_NAME }),
                variant: "contained",
            };
        }
        if (orderAuthorization === OrderAuthorizationEnum.TooMuchOffer) {
            return { id: BUTTON_IDS.MOBILE_FLOW.PAGE_CTA.GO_TO_CART, label: t("home:goCart"), variant: "contained" };
        }
        if (orderAuthorization === OrderAuthorizationEnum.OrderOk && hasMobileOfferInCart) {
            return {
                id: BUTTON_IDS.MOBILE_FLOW.PAGE_CTA.ADD_ANOTHER_GOMO_MOBILE,
                label: t("glossary:addAnotherMobileOffer", { brand: BRAND_NAME }),
                variant: "outlined",
            };
        }

        return { id: BUTTON_IDS.MOBILE_FLOW.PAGE_CTA.BUY_GOMO_MOBILE, label: t("home:buyNow"), variant: "contained" };
    };

    const cannotOrder = orderAuthorization
        ? [OrderAuthorizationEnum.TooMuchOffer, OrderAuthorizationEnum.OrderImpossible].includes(orderAuthorization)
        : false;

    const crossSellCannotOrder = orderAuthorization === OrderAuthorizationEnum.OrderImpossible;

    return {
        onClick,
        getButtonProps,
        cannotOrder,
        crossSellCannotOrder,
        firstUsage,
        otherUsages,
    };
};
